module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "reviewPage",
    attrs: {
      "id": "rev"
    }
  }, [_c('h2', {
    staticClass: "reviewPageHead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Acclaim for Karen Hawkins’s bestselling"), _c('br'), _vm._v("\nromantic novels…")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_c('span', [_vm._v("“Luscious, romantic, witty, sexy, and emotional.”")])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageSource"
  }, [_c('span', [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Romantic Times")])])])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_c('span', [_vm._v("“Fast paced, lively, sexy and laugh-out-loud funny.”")])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageSource"
  }, [_c('span', [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Romance and More!")])])])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_c('span', [_vm._v("“Delightful…sparkling.”")])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageSource"
  }, [_c('span', [_vm._v("—Mary Balogh")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05221d7f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781416538318_rev.vue
// module id = 57
// module chunks = 0